import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-seleccionar-fuente-codigo-registro',
  templateUrl: './seleccionar-fuente-codigo-registro.component.html',
  styleUrls: ['./seleccionar-fuente-codigo-registro.component.scss'],
})
export class SeleccionarFuenteCodigoRegistroComponent implements OnInit {
  escanear:number=0;
  subir:number=0;
  constructor(
    public dialogRef: MatDialogRef<SeleccionarFuenteCodigoRegistroComponent>, 
    private utilidades:UtilidadesService
  ) {}

  ngOnInit() {}

  Cerrar(dato): void {
    this.dialogRef.close(dato);
  }

  CodigoQR(ev){
    // log(ev)
    if(this.VerificarValidesQR(ev)){
      let QRSplit = String(ev).split("/")
      let QR = QRSplit[QRSplit.length-1]
   
      this.Cerrar({"Valor": atob(QR)})
    }else{
      this.utilidades.Alerta("Codigo QR no valido")
      this.Cerrar(null)
    }
    
  }




  
  VerificarValidesQR(QR:string):boolean{
    if(QR.indexOf("/Code/")>-1){
      return true;
    }

    return false;
  }


  Error(ev){
    this.utilidades.Alerta("Se ha detectado un error durante el acceso a la cámara");
    this.Cerrar(null)
  }
}
